module.exports = __webpack_public_path__ + "img/place.0702be1a.png";